import { Col, Row } from "reactstrap";
import Card from "./Card/Card";

const Creation = () => {
  const data = [
    {
      title: "Sponsored Products",
      image: `https://placehold.co/325x217?text=Sponsored+Products`,
      desc: "Details about this",
      link: "/advertisement/creation/sponsored-products",
    },
    {
      title: "Sponsored Brands",
      image: "https://placehold.co/325x217?text=Sponsored+Brands",
      desc: "Details about this",
      link: "/advertisement/creation/sponsored-brands",
    },
    {
      title: "Sponsored Display",
      image: "https://placehold.co/325x217?text=Sponsored+Display",
      desc: "Details about this",
      link: "/advertisement/creation/sponsored-display",
    },
    {
      title: "Banner Ads",
      image: "https://placehold.co/325x217?text=Sponsored+Ads",
      desc: "Details about this",
      link: "/advertisement/creation/sponsored-banner-ads",
    },
  ];

  return (
    <div style={{ background: "#f2f2f2", minHeight: "100dvh", padding: "20px" }}>
      <h4 className="fw-semibold mb-3">Advertisement Campaign Creation</h4>
      <Row className="g-0 row-gap-3">
        {data.map((item) => (
          <Col lg={6} xxl={4} className="pe-lg-3">
            <Card
              title={item.title}
              image={item.image}
              desc={item.desc}
              link={item.link}
            />
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default Creation;